import { Box, Modal, Typography } from '@mui/material'
import Image from 'mui-image'
import React from 'react'

import CrossIcon from '../../../Assets/cross.svg'

const CustomModal = ({
  isOpen, //? State to open modal
  handleClose, //? Function to Close Modal
  title, //? Title of Modal
  width = `fit-content`,
  maxHeight = `80vh`,
  bgcolor = `background.paper`,
  border = `none`,
  variant = 'heading4',
  borderRadius = '10px',
  boxShadow,
  p = 4,
  overflow = 'auto',
  children,
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: `absolute`,
          top: `50%`,
          left: `50%`,
          transform: `translate(-50%, -50%)`,
          width: width,
          maxHeight: maxHeight,
          overflow: overflow, // Enable scrolling
          scrollbarWidth: `thin`,
          bgcolor: bgcolor,
          border: border,
          outline: 'none', // Ensure no outline or border
          boxShadow: boxShadow,
          borderRadius: borderRadius,
          p: p,
        }}
      >
        <Box display={`flex`} justifyContent={`space-between`}>
          <Typography id={`modal-${title}`} variant={variant}>
            {title}
          </Typography>

          <Box
            sx={{
              ':hover': {
                cursor: `pointer`,
              },
            }}
          >
            <Image
              src={CrossIcon}
              alt="close"
              width={15}
              height={15}
              onClick={handleClose}
              duration={0}
            />
          </Box>
        </Box>
        {children}
      </Box>
    </Modal>
  )
}

export default CustomModal
